import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '@/router/auth'
import Estico from '@/router/estico'
import Order from '@/router/order'
import Subscription from '@/router/subscription'
import Account from '@/router/account'
import Customer from '@/router/customer'
import Settings from '@/router/settings'
import Stores from '@/router/store'
import store from '@/store'

Vue.use(VueRouter)

const trackPixel = (page) => {
  window.fbq('track', 'ViewContent', {
    content_name: page
  })
}

const routes = [
  {
    path: '/',
    name: 'painel',
    redirect: { name: 'dashboard' },
    component: () => import(/* webpackChunkName: "layout.painel" */ '../views/layouts/app.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        meta: {
          title: 'Dashboard',
          auth: true,
          RedirectIfAuthenticated: false
        },
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/Home.vue')
      },
      ...Estico,
      ...Order,
      ...Subscription,
      ...Account,
      ...Settings,
      ...Stores,
      ...Customer
    ]
  },
  Auth,
  {
    path: '*',
    name: 'not_found',
    component: () => import(/* webpackChunkName: "layout.painel" */ '../views/404.vue')
  }
]

const waitForStorageToBeReady = async (to, from, next) => {
  await store.restored
  next()
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'border-b-4 border-indigo-400',
  linkExactActiveClass: ''
})

router.beforeEach(waitForStorageToBeReady)
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? process.env.VUE_APP_NAME + ' - ' + to.meta.title : process.env.VUE_APP_NAME
  const state = JSON.parse(localStorage.getItem('vuex'))
  // const user = JSON.parse(state.user) ?? {}

  if (state.access_token === null && to.meta.auth) {
    return next({ name: 'login' })
  }
  if (state.store.id === null && to.name !== 'store.create' && state.access_token) {
    return next({ name: 'store.create' })
  }
  next()
})

router.afterEach((to, from) => {
  trackPixel(to.meta.title)
})
export default router
